import React from 'react';

import NewTabLink from 'components/composites/NewTabLink';
import constructEnterpriseDomain, { InputForEnterpriseDomain } from 'utils/construct-enterprise-domain';

interface Props {
  enterprise: InputForEnterpriseDomain;
  disabled?: boolean;
}

function EnterpriseLink({
  enterprise,
  disabled = false
}: Props): JSX.Element {
  const href = constructEnterpriseDomain(enterprise);

  return <NewTabLink disabled={disabled} href={href} iconSize={22} />;
}

export default EnterpriseLink;
